module.exports = __webpack_public_path__ + "img/egomi.4e27a2f.svg";